module.exports = __webpack_public_path__ + "static/media/patient-story-avatar-bruce.3029881b.svg";